module.exports = __webpack_public_path__ + "media/ko_kr_s3_KyungMi.e2de6691.mp3";